<header>
    <mat-toolbar class="border-primary-700 border-b !bg-white fixed top-0 z-50">
        <mat-toolbar-row class="!p-0">
            <span class="ml-10 text-tertiary-900 text-3xl font-normal">
                FCC License Application
            </span>

            <app-application-header-info
                class="w-full ml-4"
            ></app-application-header-info>

            <div class="mx-5 flex justify-end w-full">
                <app-header-dropdown [isMobile]="false"></app-header-dropdown>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>
</header>
